// src/config.js

const isLocalhost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('localhost')
  );
  
  const isNodeEnvDev = typeof process !== 'undefined' && process.env?.NODE_ENV === 'development';
  
  const isDevelopment = isNodeEnvDev || isLocalhost;
  
  const DEV_URL = 'http://127.0.0.1:8000/api';
  const PROD_URL = 'https://api.liftipoa.com/api';
  
  const BASE_URL = isDevelopment ? DEV_URL : PROD_URL;
  
  if (isDevelopment) {
    console.log(`API Base URL: ${BASE_URL} (Development mode)`);
  }
  
  export default BASE_URL;
  export { DEV_URL, PROD_URL, isDevelopment };
  